import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const SmallCarouselContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    width: "100%",
    maxWidth: "1070px",
    margin: "2rem auto",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 1rem",
    [theme.breakpoints.down("md")]: {
        maxWidth: "96%",
    },
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));

export const SmallSliderWrapper = styled(Box)(() => ({
    width: "100%", 
    display: "flex",
    alignItems: "center",
    transition: "transform 0.4s ease",
    overflowX: "auto", 
    scrollBehavior: "smooth",
    scrollSnapType: "x mandatory",
    "&::-webkit-scrollbar": {
        display: "none",
    },
}));

export const SmallSlide = styled(Box)(() => ({
    flex: "0 0 100%",
    height: "180px",
    borderRadius: "12px",
    backgroundColor: "#f7f9fc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    overflow: "hidden",
    cursor: "pointer",
    scrollSnapAlign: "start",
    "@media (max-width: 1024px)": {
        flex: "0 0 100%",
        height: "140px",
    },
}));

export const ArrowButton = styled(Box)(({ left }) => ({
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    [left ? "left" : "right"]: "0px",
    width: "40px",
    height: "40px",
    backgroundColor: "#B3B7BE",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    cursor: "pointer",
    transition: "background 0.3s ease",
    zIndex: 2,
}));
